"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const typography_1 = __importDefault(require("../../typography/typography"));
const BarChart = ({ cardComponent }) => (react_1.default.createElement("div", { className: "card-content-header bar-chart" },
    react_1.default.createElement(typography_1.default, { variant: "body1", className: "display-name" }, cardComponent.displayName),
    react_1.default.createElement(typography_1.default, { variant: "caption", className: "description" }, cardComponent.description)));
exports.default = BarChart;
//# sourceMappingURL=bar-chart.js.map